import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV } from "@/constants/testIds";

const LOGO_GREEN = "https://customer-assets.emergentagent.com/job_0fbf747e-f9ce-419f-bd04-07b0f1580b22/artifacts/kzjb8rg1_Tarzan%20logo.png";
const LOGO_WHITE = "https://customer-assets.emergentagent.com/job_0fbf747e-f9ce-419f-bd04-07b0f1580b22/artifacts/snl5ovgh_logo02.png";

const LINKS = [
  { to: "/stays",         label: "Destinations", testId: NAV.explore },
  { to: "/experiences",   label: "Experiences",  testId: NAV.experiences },
  { to: "/gallery",       label: "Gallery",      testId: "nav-gallery" },
  { to: "/about",         label: "About",        testId: "nav-about" },
  { to: "/partner",       label: "Partner With Us", testId: "nav-partner" },
];

export default function Navbar() {
  const { pathname } = useLocation();
  const isHome = pathname === "/";
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [pathname]);

  const onDarkHero = isHome && !scrolled;
  const headerBg = onDarkHero
    ? "bg-transparent"
    : "bg-ivory/85 backdrop-blur-xl border-b border-forest/10";
  const textBase = onDarkHero ? "text-ivory" : "text-ink";

  return (
    <header className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${headerBg}`}>
      <div className="container-tarzan flex items-center justify-between h-20 md:h-24">
        <Link to="/" data-testid={NAV.logo} className="flex items-center shrink-0">
          <img
            src={onDarkHero ? LOGO_WHITE : LOGO_GREEN}
            alt="Tarzan Nature Retreat"
            className="h-12 md:h-14 w-auto object-contain transition-opacity"
            loading="eager"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testId}
              className={({ isActive }) =>
                `relative text-[13px] uppercase tracking-[0.18em] font-medium transition-colors ${textBase} hover:opacity-80 ${
                  isActive ? "after:absolute after:-bottom-2 after:left-0 after:right-0 after:h-px after:bg-current" : ""
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-5">
          <Link
            to="/stays/tarzan-hyderabad-retreat"
            data-testid={NAV.bookNow}
            className="bg-forest text-ivory px-6 py-2.5 rounded-full text-sm font-medium tracking-wide hover:bg-forest-700 transition-all hover:-translate-y-0.5"
          >
            Book Now
          </Link>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          data-testid={NAV.mobileToggle}
          className={`lg:hidden p-2 ${textBase}`}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-ivory border-t border-forest/10">
          <div className="container-tarzan py-6 flex flex-col gap-5">
            {LINKS.map((l) => (
              <Link key={l.to} to={l.to} className="text-ink text-base font-medium tracking-wide">
                {l.label}
              </Link>
            ))}
            <div className="flex gap-3 pt-2 border-t border-forest/10">
              <Link to="/stays/tarzan-hyderabad-retreat" className="flex-1 bg-forest text-ivory text-center py-3 rounded-full font-medium">Book Now</Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
